import { render, staticRenderFns } from "./myCreatedNtfs.vue?vue&type=template&id=5c6f7c12&scoped=true"
import script from "./myCreatedNtfs.vue?vue&type=script&lang=js"
export * from "./myCreatedNtfs.vue?vue&type=script&lang=js"
import style0 from "./myCreatedNtfs.vue?vue&type=style&index=0&id=5c6f7c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f7c12",
  null
  
)

export default component.exports